export default __webpack_public_path__ + "static/piano-480f317f5e7f9878a85d10ec4aafb320.jpg";